<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tipogarant">
    <fieldset id="agregar_tipogarant" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>
                    <div class="form-horizontal titulo">
                        <div class="form-group" align="left">
                            <div class="col-md-2">
                                <label for="tipogarant">Tipo de Solicitud:</label>
                            </div>
                            <div class="col-md-10" class="inline" style="font-size: 13px">
                                <div class="col-md-10">
                                    <mat-checkbox (change)="add_tipo_garantia()" [(ngModel)]="garantia['DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA']" name="garantia" value="1">DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA</mat-checkbox>
                                </div>
                                <div class="col-md-2"></div>
                                <div class="col-md-10">
                                    <mat-checkbox (change)="add_tipo_garantia()" [(ngModel)]="garantia['COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA']" name="garantia" value="2">COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>